export default class SessionLocation {
  sessionLocationId?: number | null;
  legacyLocationId?: number | null;
  name?: Date | null;
  public constructor(params: SessionLocation = {} as SessionLocation) {
    let {
      sessionLocationId = 0,
      legacyLocationId = null,
      name = null,
    } = params;
    this.sessionLocationId = sessionLocationId;
    this.legacyLocationId = legacyLocationId;
    this.name = name;
  }
}
